import axios from '../api/axios';

// State Management API Services
export const stateManagementAPI = {
  // States
  getStates: async (page = 1, limit = 10, search = '') => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (search) params.append('search', search);

      const response = await axios.get(`/states?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching states:', error);
      throw error;
    }
  },

  createState: async (stateData) => {
    try {
      const response = await axios.post('/admin/states', stateData);
      return response.data;
    } catch (error) {
      console.error('Error creating state:', error);
      throw error;
    }
  },

  updateState: async (stateId, stateData) => {
    try {
      const response = await axios.put(`/admin/states/${stateId}`, stateData);
      return response.data;
    } catch (error) {
      console.error('Error updating state:', error);
      throw error;
    }
  },

  deleteState: async (stateId) => {
    try {
      const response = await axios.delete(`/admin/states/${stateId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting state:', error);
      throw error;
    }
  },

  // Commissionaries
  getCommissionaries: async (stateId, page = 1, limit = 10, search = '') => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (stateId) {
        params.append('stateId', stateId);
      }

      if (search) params.append('search', search);

      const response = await axios.get(`/commissionary?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching commissionaries:', error);
      throw error;
    }
  },

  createCommissionary: async (commissionaryData) => {
    try {
      const response = await axios.post('/admin/commissionary', commissionaryData);
      return response.data;
    } catch (error) {
      console.error('Error creating commissionary:', error);
      throw error;
    }
  },

  updateCommissionary: async (commissionaryId, commissionaryData) => {
    try {
      const response = await axios.put(`/admin/commissionary/${commissionaryId}`, commissionaryData);
      return response.data;
    } catch (error) {
      console.error('Error updating commissionary:', error);
      throw error;
    }
  },

  deleteCommissionary: async (commissionaryId) => {
    try {
      const response = await axios.delete(`/admin/commissionary/${commissionaryId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting commissionary:', error);
      throw error;
    }
  },

  // Districts
  getDistricts: async (commissionaryId, page = 1, limit = 10, search = '') => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (commissionaryId) {
        params.append('commissionaryId', commissionaryId);
      }
      if (search) params.append('search', search);

      const response = await axios.get(`/districts?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching districts:', error);
      throw error;
    }
  },

  createDistrict: async (districtData) => {
    try {
      const response = await axios.post('/admin/districts', districtData);
      return response.data;
    } catch (error) {
      console.error('Error creating district:', error);
      throw error;
    }
  },

  updateDistrict: async (districtId, districtData) => {
    try {
      const response = await axios.put(`/admin/districts/${districtId}`, districtData);
      return response.data;
    } catch (error) {
      console.error('Error updating district:', error);
      throw error;
    }
  },

  deleteDistrict: async (districtId) => {
    try {
      const response = await axios.delete(`/admin/districts/${districtId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting district:', error);
      throw error;
    }
  },

  // Analytics
  getStateAnalytics: async () => {
    try {
      const response = await axios.get('/analytics/states');
      return response.data;
    } catch (error) {
      console.error('Error fetching state analytics:', error);
      throw error;
    }
  }
};